import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export function useApiWithAuth() {
  const { instance, accounts } = useMsal();
  let interactionInProgress = false;

  // Helper to get access token
  const getAccessToken = async () => {
    if (accounts.length === 0) {
      if (!interactionInProgress) {
        interactionInProgress = true;
        try {
          await instance.loginPopup(loginRequest);
        } finally {
          interactionInProgress = false;
        }
      } else {
        throw new Error("Interaction already in progress");
      }
    }
    try {
      const result = await instance.acquireTokenSilent({
        ...loginRequest,
        account: instance.getAllAccounts()[0],
      });
      return result.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        if (!interactionInProgress) {
          interactionInProgress = true;
          try {
            const result = await instance.acquireTokenPopup({
              ...loginRequest,
              account: instance.getAllAccounts()[0],
            });
            return result.accessToken;
          } finally {
            interactionInProgress = false;
          }
        } else {
          throw new Error("Interaction already in progress");
        }
      } else {
        throw error;
      }
    }
  };

  // Authenticated fetch
  const fetchWithAuth = async (url, options = {}) => {
    const token = await getAccessToken();
    if (!token) {
      console.error('No access token retrieved. Authorization header will be missing.');
      throw new Error('Authorization header missing. Please log in again.');
    }

    return fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${token}`,
      },
    });
  };

  return { fetchWithAuth };
}
